import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {filterElements, filterInputStyle} from 'utils/General';
import AvatarImage from 'assets/images/profile.png';
import {handleElementSelect, handleSelectAll} from 'utils/ComponentUtilFunctions';
import removeAgent from 'assets/images/removeAgent.svg';
import '../styles/client-member-list.css';
import Translate, {t} from '../../../../../components/Translate';
import {deleteSkillFromOperator, signSkillToOperator} from "../../../../../services/company/api";
import TranslateProperty from "../../../../../components/TranslateProperty";
import config from "../../../../../config";

const searchBackgroundColorStyle = {
    backgroundColor: 'transient',
};


class ConnectedMembers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            nameFilter: '',
            selectedIds: [],
            operatorSkills: this.initializeOperatorSkills(props.connectedMembers),
        };
        this.handleSelectAll = handleSelectAll(this.getFilteredMembers, this);
        this.handleMemberSelect = handleElementSelect.bind(this);
    }

    initializeOperatorSkills = (members) => {
        const {client, skills} = this.props;

        return members.reduce((acc, member) => {
            if (!member.skills) return acc;

            acc[member.id] = member.skills
                .filter(s => s.companyId === client.id)
                .map(skill => {
                    const matchedSkill = skills.find(s => s.id === skill.id);
                    return {
                        ...skill,
                        name: matchedSkill ? matchedSkill.name : skill.name
                    };
                });

            return acc;
        }, {});
    };

    componentDidUpdate(prevProps) {
        if (prevProps.connectedMembers !== this.props.connectedMembers) {
            this.setState({
                operatorSkills: this.initializeOperatorSkills(this.props.connectedMembers),
            });
        }
    }

    getFilteredMembers = () => {
        const {connectedMembers} = this.props;
        const {selectedIds} = this.state;

        return filterElements(connectedMembers, '', member => selectedIds.includes(member.id));
    };

    handleNameFilterChange = (text) => {
        this.setState({nameFilter: text});
    };

    filterByName = () => {
        const {nameFilter} = this.state;

        return this.getFilteredMembers().filter(op => {
            return (op.firstName + " " + op.lastName).toLowerCase().includes(nameFilter.toLowerCase())
        });
    }

    removeSelectedMembers = () => {
        const {connectedMembers} = this.props;
        const {selectedIds} = this.state;
        const selectedMembers = connectedMembers.filter(member => selectedIds.includes(member.id));
        this.removeMembersFromClient(selectedMembers);
    };

    removeMembersFromClient = (members) => {
        const {removeMembersFromClient, client} = this.props;
        removeMembersFromClient(members, client).then(() => {
            const {selectedIds} = this.state;
            this.setState({
                selectedIds: selectedIds.filter(id => members.findIndex(member => member.id === id) === -1),
            });
        });
    };

    addSkillToMember = (operatorId, selectedSkillId) => {
        const {connectedMembers} = this.props
        let selectedSkill;

        this.props.skills.map(skill => {
            if (skill.id == selectedSkillId) {
                selectedSkill = skill;
            }
        })

        if (!selectedSkill) {
            return;
        }

        signSkillToOperator(operatorId, selectedSkillId).then(() => {
            connectedMembers.filter(cm => cm.id === operatorId)[0].skills.push(selectedSkill)
            this.setState((prevState) => ({
                operatorSkills: {
                    ...prevState.operatorSkills,
                    [operatorId]: [
                        ...(prevState.operatorSkills[operatorId] || []),
                        selectedSkill,
                    ],
                },
            }));
        }).catch((error) => {
            console.error('Error signing skill to operator:', error);
        });
    };

    removeSkillFromMember = (operatorId, skillId) => {
        const {connectedMembers} = this.props;

        deleteSkillFromOperator(operatorId, skillId).then(() => {
            const operator = connectedMembers.find(cm => cm.id === operatorId);
            if (operator) {
                operator.skills = operator.skills.filter(skill => skill.id !== skillId);
            }

            this.setState((prevState) => ({
                operatorSkills: {
                    ...prevState.operatorSkills,
                    [operatorId]: prevState.operatorSkills[operatorId].filter(skill => skill.id !== skillId),
                },
            }));
        }).catch((error) => {
            console.error('Error removing skill from operator:', error);
        });
    };

    render() {
        const {nameFilter, selectedIds, operatorSkills} = this.state;
        const {skills, user, client, tariff} = this.props;
        const filteredMembers = this.filterByName();

        const {features} = tariff;

        skills.filter(skill => skill.companyId === client.id);

        return (
            <div style={{padding: '20px'}}>
                <br/>
                <div style={{marginBottom: '20px', display: 'flex', gap: '20px', justifyContent: 'center'}}>
                    <TranslateProperty properties={[{
                        key: 'placeholder',
                        value: 'searchByOperator'
                    }]}>
                        <input
                            type="text"
                            value={nameFilter}
                            onChange={(e) => this.handleNameFilterChange(e.target.value)}
                            style={filterInputStyle}
                        />
                    </TranslateProperty>
                </div>

                <table className="custom-table">
                    <thead>
                    <tr className="table-head">
                        <th>
                            <input
                                type="checkbox"
                                checked={filteredMembers.length === selectedIds.length && filteredMembers.length}
                                onChange={this.handleSelectAll}
                            />
                        </th>
                        <th>
                            <div style={searchBackgroundColorStyle}>
                                <Translate text="operator"/>
                            </div>
                        </th>

                        {features.includes(config.features.SKILLS) && (
                            <React.Fragment>
                                <th style={{textAlign: 'center'}}><Translate text="assignSkill"/></th>
                                <th style={{textAlign: 'center'}}><Translate text="skills"/></th>
                            </React.Fragment>
                        )}

                        <th style={{textAlign: "right"}} className="add-header table-header">
                            <button
                                type="button"
                                className="no-style-button"
                                style={{visibility: selectedIds.length > 0 ? 'visible' : 'hidden'}}
                                onClick={this.removeSelectedMembers}
                            >
                                <Translate text="remove"/>{` (${selectedIds.length})`}
                            </button>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    {filteredMembers.map(member => (
                        <tr key={member.id} className="body-row">
                            <td className="checkbox-header">
                                <input
                                    type="checkbox"
                                    checked={selectedIds.includes(member.id)}
                                    onChange={this.handleMemberSelect(member.id)}
                                />
                            </td>

                            <td className="user-info">
                                <div style={{display: 'flex', alignItems: 'center', gap: '5px'}}>
                                    <img src={member.thumbUrl || AvatarImage} alt="Avatar" className="avatar"/>
                                    <div style={{display: 'flex', flexDirection: 'column'}}>
                                        <span className="name-text">{`${member.firstName} ${member.lastName}`}</span>
                                        <span className="email-text">{member.email}</span>
                                    </div>
                                </div>
                            </td>

                            {features.includes(config.features.SKILLS) && (
                                <React.Fragment>
                                    <td style={{textAlign: 'center'}}>
                                        <select
                                            style={filterInputStyle}
                                            onChange={(event) => {
                                                const selectedSkillId = event.target.value;
                                                if (selectedSkillId) {
                                                    this.addSkillToMember(member.id, selectedSkillId);
                                                }
                                            }}
                                        >
                                            <option value="">{t({text: "choose", user})}</option>
                                            {skills.map((s) => (
                                                <option key={s.id} value={s.id}>{s.name}</option>
                                            ))}
                                        </select>
                                    </td>
                                    <td style={{textAlign: 'center'}}>
                                        <div
                                            className="skills-container"
                                            style={{
                                                display: 'flex',
                                                flexWrap: 'wrap',
                                                gap: '10px',
                                                alignItems: 'center',
                                                justifyContent: 'center'
                                            }}
                                        >
                                            {(operatorSkills[member.id] || []).map(skill => (
                                                <div
                                                    key={skill.id}
                                                    style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        gap: '5px',
                                                        backgroundColor: 'rgb(4, 62, 92)',
                                                        padding: '5px 10px',
                                                        borderRadius: '15px',
                                                        border: '1px solid #b2ebf2',
                                                    }}
                                                >
                                                    <span style={{fontSize: '14px', color: 'white'}}>{skill.name}</span>
                                                    <button
                                                        className="remove-skill-btn"
                                                        style={{
                                                            border: 'none',
                                                            background: 'none',
                                                            color: '#d32f2f',
                                                            fontSize: '16px',
                                                            cursor: 'pointer',
                                                            fontWeight: 'bold',
                                                            lineHeight: '1',
                                                        }}
                                                        onClick={() => this.removeSkillFromMember(member.id, skill.id)}
                                                    >
                                                        ✕
                                                    </button>
                                                </div>
                                            ))}
                                        </div>
                                    </td>
                                </React.Fragment>
                            )}

                            <td style={{textAlign: 'right'}} className="add-cell">
                                <img
                                    className="remove-image"
                                    src={removeAgent}
                                    onClick={() => this.removeMembersFromClient([member])}
                                    role="presentation"
                                    alt="not found"
                                />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>
        );
    }
}

ConnectedMembers.propTypes = {
    connectedMembers: PropTypes.array.isRequired,
    client: PropTypes.object.isRequired,
    removeMembersFromClient: PropTypes.func.isRequired,
};

export default ConnectedMembers;



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/management/clients/ConnectedMembers.jsx